module.exports = __webpack_public_path__ + "media/gili/small_shacks-b82a106e.jpg";